<template lang="pug">
.date-picker-single
  v-date-picker(
    mode='dateTime',
    v-model='selectedDate',
    :popover='{ visibility: "focus", keepVisibleOnInput: false }',
    is24hr
  )
    template(v-slot='{ inputValue, inputEvents }')
      .date-picker-single__input
        input.date-picker-single__input__form(
          :value='parseDateTime(inputValue)',
          v-on='inputEvents',
          :disabled='disabled',
          :placeholder='placeholder',
          readonly
        )
        .date-picker-single__input__clear(v-if='selectedDate && !disabled', @click='clearDate')
          image-base.date-picker-single__input__clear__icon(:src='require("@/assets/img/common/icon/close.svg")')
    template(slot='header-title', slot-scope='props')
      | {{ props.yearLabel }}年{{ props.monthLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import '@/assets/css/datepicker.styl'

/**
 * 単体選択用の日付ピッカー
 */
@Component({
  components: {
    ImageBase,
  },
})
export default class DatePickerSingle extends Vue {
  // 入力値（日時）
  @Prop()
  value!: Date | null

  // 編集不可
  @Prop({ default: false })
  disabled?: boolean

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // 入力日付ゲッター・セッター
  get selectedDate(): Date | null {
    return this.value
  }

  set selectedDate(value: Date | null) {
    this.$emit('input', value)
  }

  /**
   * 日付クリア
   */
  private clearDate(): void {
    this.selectedDate = null
  }

  /**
   * dateTimeモードはmasksが上手く動作しないのでパースする
   */
  private parseDateTime(dateStr: string) {
    const match = /(\d{4})年(\d{1,2})月(\d{1,2})日\s(\d{2}):(\d{2})/.exec(dateStr)
    if (!match) return ''

    const dateTime = this.$localDateFns.formatDateTime(
      new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]), parseInt(match[4]), parseInt(match[5]))
    )
    return `${dateTime.date} ${dateTime.time}`
  }
}
</script>

<style lang="stylus" scoped>
.date-picker-single
  display flex

  &__input
    position relative
    display flex

    &__form
      width 510px
      height 42px
      padding 13px 16px
      border-radius 10px
      background-color var(--color-input-manager-setting-textbox__background)
      border 1px solid var(--color-input-manager-setting-textbox__border)
      transition-timing-function ease-out
      transition-duration 300ms

      &:hover, &:focus
        border-color var(--color-input-manager-setting-textbox__border-hover)
        background-color transparent

      &:disabled
        background-color var(--color-input-manager-setting-textbox__background-disabled)
        border-color var(--color-input-manager-setting-textbox__border-disabled)
        cursor default

    &__clear
      position absolute
      top 13px
      right 16px
      cursor pointer

      &__icon
        width 16px
        height 16px
        opacity 0.3
</style>
